import React from "react";
import logo from "assests/white-black-logo.png";
import "./Style.css";

const LoadingScreen = ({ progress }) => {
  return (
    <div className="h-[100vh] bg-black flex flex-col justify-center items-center">
      <div>
        <img className="w-[60%] mx-auto" src={logo} alt="logo" />
      </div>

      <div className="w-full flex justify-start mt-10">
        <div
          className="loading-bar"
          style={{ width: `${progress}vw` }} // Dynamically update width based on progress
        ></div>
      </div>
    </div>
  );
};

export default LoadingScreen;
